import type { HomePhase } from "@/components/v2/home/types";

/** Player-facing status for a specific poll public link (one link per poll). */
export type PublicCycleLinkStatus =
  | "active"
  | "cycle_closed"
  | "stale_link"
  | "poll_cancelled"
  | "match_cancelled";

export function isTerminalPublicLinkStatus(
  status: PublicCycleLinkStatus
): status is Exclude<PublicCycleLinkStatus, "active"> {
  return status !== "active";
}

export interface DerivePublicLinkStatusInput {
  pollStatus: string | null | undefined;
  linkedEventStatus: string | null | undefined;
  hasNewerOpenPoll: boolean;
  phase: HomePhase;
}

/**
 * Resolve whether a public invite link should show active Home phases or a terminal screen.
 * Keep in sync with derivePublicLinkStatus() in supabase/functions/public-cycle/index.ts.
 */
export function derivePublicLinkStatus(
  input: DerivePublicLinkStatusInput
): PublicCycleLinkStatus {
  if (input.pollStatus === "cancelled") {
    return "poll_cancelled";
  }

  if (input.hasNewerOpenPoll) {
    return "stale_link";
  }

  if (input.linkedEventStatus === "cancelled") {
    return "match_cancelled";
  }

  if (input.phase === "poll_inactive") {
    return "cycle_closed";
  }

  return "active";
}
